module.exports = "<div [appBlockContent]=\"itemData.gutenberg_blocks\"></div>\n"